// §25.6 / §9.1 — Intercept as an in-process app.
//
// Gated like the rest of the Arcade (D-200); manifest only (D-247). A **factory** since M30, for
// Conquest's reason: the co-op half of §26.7 needs a session, and `HangarAPI` carries none.
import type { InProcessApp, PlayShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createInterceptApp(play: PlayShellAccess): InProcessApp {
  return createLazyApp<{ play: PlayShellAccess }>({
    app: {
      id: 'intercept',
      name: 'Intercept',
      icon: { glyph: 'target', hue: 15 },
      keywords: ['missile', 'defence', 'defense', 'cities', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Action',
      requiresAuth: true,
      // Fixed 4:3, letterboxed (D-229) — and here the fixed fit is what keeps the pointer honest,
      // since a stretched playfield would put the crosshair somewhere other than the cursor.
      window: { width: 880, height: 720, minWidth: 560, minHeight: 460, multiWindow: false },
      jumpList: [{ id: 'new-game', label: 'New game' }],
    },
    load: () => import('./Intercept'),
    props: { play },
  });
}
